import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.395 10.848 18.86 4.5h-1.293l-4.748 5.516L9.031 4.5H4.666l5.734 8.332L4.666 19.5H5.96l5.004-5.823L14.97 19.5h4.365l-5.939-8.652Zm-1.779 2.06-.576-.831-4.607-6.604h1.983l3.725 5.337.576.832 4.85 6.936h-1.983l-3.955-5.656-.013-.013Z",
      fill: "#616a75"
    }, null, -1)
  ])))
}
export default { render };